export const ACCOUNT_TIMELINE_FETCH_QUERIES = {
  fetchCasesForAccount: `
<fetch {{count}} version="1.0" output-format="xml-platform" mapping="logical" distinct="true">
    <entity name="incident">
        <attribute name="title" />
        <attribute name="statuscode" />
        <attribute name="ticketnumber" />
        <attribute name="createdon" />
        <attribute name="incidentid" />
        <attribute name="indskr_expertcategory"/>
        <attribute name="indskr_expertcategorytype"/>
        <attribute name="indskr_omnipresencestage" />
        <attribute name="ownerid"/>
        <attribute name="indskr_casetype"/>
        <attribute name="productid"/>
        <order attribute="createdon" descending="true" />
        <filter type="and">
            <condition attribute="indskr_account" operator="eq" value="{{accountId}}" /> {{owneridPlaceholder}}
        </filter>
        <link-entity name="systemuser" from="systemuserid" to="owninguser">
            <attribute name="fullname" alias="indskr_ownerfullname"/>
            <attribute name="systemuserid" alias="indskr_ownerid"/> {{businessUnitPlaceholder}}
        </link-entity>
    </entity>
</fetch>
`,

  fetchMeetingsForAccount: `
<fetch {{count}} version="1.0" output-format="xml-platform" mapping="logical" distinct="true">
    <entity name='appointment'>
        <attribute name='subject'/>
        <attribute name='statecode'/>
        <attribute name='scheduledstart'/>
        <attribute name='scheduledend'/>
        <attribute name='activityid'/>
        <attribute name='location'/>
        <attribute name='activitytypecode'/>
        <order attribute='scheduledstart' descending='true'/>
        <link-entity name='indskr_activityaccount' from='indskr_appointmentid' to='activityid' link-type='inner'>
            <filter type='and'>
                <condition attribute='indskr_accountid' operator='eq' value='{{accountId}}'/>
            </filter>
        </link-entity>
        <link-entity name="indskr_activityaccount" from="indskr_appointmentid" to="activityid" link-type="outer" alias="account">
          <attribute name="indskr_accountid"/>
        </link-entity>
        <link-entity name="systemuser" from="systemuserid" to="owninguser">
            <attribute name="fullname" alias="indskr_ownerfullname"/>
            <attribute name="systemuserid" alias="indskr_ownerid"/> {{businessUnitPlaceholder}}
        </link-entity>
        <filter type="and">{{owneridPlaceholder}}</filter>
        <link-entity name='indskr_activityplaylist' from='indskr_appointmentid' to='activityid' link-type='outer' alias='playlist'>
            <link-entity name="indskr_iopresentation" from="indskr_iopresentationid" to="indskr_iopresentationid" link-type="outer">
                <attribute name="indskr_ckmthumbnailurl" alias="pre_thumbnailUrl"/>
                <attribute name="indskr_name" alias="presentationName"/>
                <attribute name="indskr_iopresentationid" alias="presentationId"/>
            </link-entity>
            <link-entity name="indskr_ioresource" from="indskr_ioresourceid" to="indskr_ioresourceid" link-type="outer">
                <attribute name="indskr_ckmthumbnailurl" alias="res_thumbnailUrl"/>
                <attribute name="indskr_title" alias="resourceName"/>
                <attribute name="indskr_ioresourceid" alias="resourceId"/>
            </link-entity>
            <link-entity name="indskr_iodocument" from="indskr_iodocumentid" to="indskr_iodocumentid" link-type="outer">
                <attribute name="indskr_iodocumentid" alias="iodocumentId"/>
                <attribute name="indskr_ckmtitle" alias="ckmTitle"/>
                <attribute name="indskr_ckmthumbnailurl" alias="ckmThumbnailUrl"/>
            </link-entity>
        </link-entity>
        <link-entity name='indskr_accompanieduser' from='indskr_appointment' to='activityid' link-type='outer' alias='accompanieduser'>
            <attribute name='indskr_user'/>
        </link-entity>
        <link-entity name='indskr_activityproduct' from='indskr_appointmentid' to='activityid' link-type='outer' alias='product'>
            <attribute name='indskr_productid'/>
        </link-entity>
    </entity>
</fetch>
`,
  fetchPhonecallsForAccount: `
<fetch {{count}} version="1.0" output-format="xml-platform" mapping="logical" distinct="true">
    <entity name='phonecall'>
        <attribute name='subject'/>
        <attribute name='statecode'/>
        <attribute name='scheduledstart'/>
        <attribute name='scheduledend'/>
        <attribute name='activityid'/>
        <attribute name='phonenumber'/>
        <attribute name='activitytypecode'/>
        <order attribute='scheduledstart' descending='true'/>
        <filter type='and'>
          <condition attribute="statecode" operator="in">
            <value>0</value><value>1</value>
          </condition>
          {{owneridPlaceholder}}
        </filter>
        <link-entity name='indskr_activityaccount' from='indskr_phonecallid' to='activityid'>
            <filter type='and'>
                <condition attribute='indskr_accountid' operator='eq' value='{{accountId}}'/>
            </filter>
        </link-entity>
        <link-entity name="systemuser" from="systemuserid" to="owninguser">
            <attribute name="fullname" alias="indskr_ownerfullname"/>
            <attribute name="systemuserid" alias="indskr_ownerid"/> {{businessUnitPlaceholder}}
        </link-entity>
        <link-entity name="indskr_activitycontact" from="indskr_phonecallid" to="activityid" link-type="outer">
            <attribute name="indskr_contactid" alias="contactId"/>
        </link-entity>
        <link-entity name="indskr_activityproduct" from="indskr_phonecallid" to="activityid" link-type="outer">
            <attribute name="indskr_productid" alias="product"/>
        </link-entity>
    </entity>
</fetch>
`,
  fetchOrdersForAccount: `
<fetch {{count}} version="1.0" output-format="xml-platform" mapping="logical" distinct="true">
    <entity name="salesorder">
        <attribute name="name" />
        <attribute name="statuscode" />
        <attribute name="salesorderid" />
        <attribute name="statecode" />
        <attribute name="ownerid" />
        <attribute name="ordernumber" />
        <attribute name="indskr_externalid" />
        <attribute name="createdon" />
        <attribute name="indskr_ordertype" />
        <attribute name="indskr_scheduleddate" alias="scheduledstart" />
        <attribute name="indskr_scheduledenddate" alias="scheduledEnd"/>
        {{orderAttribute}}
        <filter type="and">
          {{orderType}}
            <condition attribute="customerid" operator="eq" value="{{accountId}}" />
            <condition attribute="statuscode" operator="in">
                <value>548910001</value>
                <value>100001</value>
            </condition> {{owneridPlaceholder}}
        </filter> 
        <link-entity name="systemuser" from="systemuserid" to="owninguser">
          {{businessUnitPlaceholder}}
        </link-entity>
        <link-entity name="salesorderdetail" from="salesorderid" to="salesorderid" link-type="outer" alias="order_details">
            <attribute name="productid" />
            <attribute name="productname" />
        </link-entity>
    </entity>
</fetch>
`,
  // New order flow: the account's orders, as History lists them, by last change; whose follows the timeline
  // visibility setting. Procedure logs (order types 548910001/2) stay procedure logs.
  // Every order but the Canceled ones, as History lists them.
  fetchOrderCaptureForAccount: `
<fetch {{count}} version="1.0" output-format="xml-platform" mapping="logical">
    <entity name="salesorder">
        <attribute name="salesorderid" />
        <attribute name="ordernumber" />
        <attribute name="statecode" />
        <attribute name="statuscode" />
        <attribute name="totalamount" />
        <attribute name="createdon" />
        <attribute name="modifiedon" />
        <attribute name="ownerid" />
        <attribute name="customerid" />
        <order attribute="modifiedon" descending="true" />
        <filter type="and">
            <condition attribute="customerid" operator="eq" value="{{accountId}}" /> {{owneridPlaceholder}}
            <condition attribute="statecode" operator="ne" value="2" />
            <filter type="or">
                <condition attribute="indskr_ordertype" operator="null" />
                <condition attribute="indskr_ordertype" operator="not-in"><value>548910001</value><value>548910002</value></condition>
            </filter>
        </filter>
        <link-entity name="systemuser" from="systemuserid" to="owninguser">
          {{businessUnitPlaceholder}}
        </link-entity>
    </entity>
</fetch>
`,
  fetchEmailsForAccount: `<fetch {{count}} version="1.0" output-format="xml-platform" mapping="logical" distinct="true">
    <entity name='email'>
        <attribute name='subject'/>
        <attribute name='statecode'/>
        <attribute name='statuscode'/>
        <attribute name='scheduledstart'/>
        <attribute name='scheduledend'/>
        <attribute name='activityid'/>
        <attribute name='to'/>
        <attribute name='indskr_channel'/>
        <attribute name='activitytypecode'/>
        <attribute name='senton'/>
        <attribute name='lastopenedtime' alias='readOn'/>
        <attribute name='indskr_productid' alias='product_id'/>
        <order attribute='scheduledstart' descending='true'/>
        <filter type="and">
          <condition attribute='indskr_usercreated' operator='eq' value='1'/>
          <condition attribute='statecode' operator='eq' value='1'/>
          {{owneridPlaceholder}}
        </filter>
        <link-entity name='indskr_activityaccount' from='indskr_emailmessage' to='activityid' link-type='inner'>
            <filter type='and'>
                <condition attribute='indskr_accountid' operator='eq' value='{{accountId}}'/>
            </filter>
        </link-entity>
        <link-entity name='indskr_consenttype' from='indskr_consenttypeid' to='indskr_channel'>
          <attribute name='indskr_channeltype' alias='channelType'/>
        </link-entity>
         <link-entity name="systemuser" from="systemuserid" to="owninguser">
            <attribute name="fullname" alias="indskr_ownerfullname"/>
            <attribute name="systemuserid" alias="indskr_ownerid"/> {{businessUnitPlaceholder}}
        </link-entity>
        <link-entity name="indskr_emailattachment" from="indskr_email" to="activityid" link-type="outer" alias="attachments">
          <attribute name="indskr_emailattachmentid" />
          <attribute name="indskr_ckmtitle" />
          <attribute name="indskr_ckmthumbnailurl" />
          <attribute name="indskr_resource" alias="indskr_resourceid"/>
          <attribute name="indskr_document" alias="indskr_documentid"/>
          <attribute name="indskr_ckmasseturl" />
        </link-entity>
        </entity>
      </fetch>`
}